import React from 'react';
import Highcharts from 'highcharts/highstock';
import {
  Chart,
  ColumnSeries,
  HighchartsProvider,
  HighchartsStockChart,
  Legend,
  LineSeries,
  Title,
  Tooltip,
  XAxis,
  YAxis
} from 'react-jsx-highstock';
import {primaryColor} from '../../utils';
import moment from 'moment';
import 'moment/locale/pl';

const plotOptions = {
  column: {
    // pointWidth: 6,
    // maxPointWidth: 50,
    minPointLength: 3, // By default, 0 values are not shown. To visualize a 0 (or close to zero) point, set the minimal point length to a pixel value like 3
    borderWidth: 0
  },
  series: {
    turboThreshold: 1000000,
    shadow: true,
    dataGrouping: {
      approximation: 'average',
      groupAll: true,
      groupPixelWidth: 20,
      //. An array determining what time intervals the ticks are allowed to fall on.
      // Each array item is an array where the first value is the time unit and
      // the second value another array of allowed multiples.
      // units: [
      //   [
      //     'millisecond', // unit name
      //     [] // allowed multiples
      //   ], [
      //     'second',
      //     []
      //   ], [
      //     'minute',
      //     [10]
      //   ], [
      //     'hour',
      //     [1, 4, 12]
      //   ], [
      //     'day',
      //     [1, 2]
      //   ], [
      //     'week',
      //     [1, 2]
      //   ], [
      //     'month',
      //     [1, 2, 3, 4, 6]
      //   ], [
      //     'year',
      //     null
      //   ]]
    }
  }
};


const timeOptions = {
  useUTC: true
};

const options = {
  noData: {
    style: {
      fontWeight: 'bold',
      fontSize: '15px',
      color: '#303030'
    },
    useHTML: false
  }
};

const default_units = "μg/m3";

export default function AnalyticChart({measurement, title, seriesList, columns, units=default_units}) {
  moment.locale('pl')
  // const [columns, setColumns] = useState(false);
  // const handleColumnsToggle = () => setColumns(!columns);

  return (<div>
      <HighchartsProvider Highcharts={Highcharts}>
        <HighchartsStockChart options={options} plotOptions={plotOptions} time={timeOptions}>
          {/*<Chart zoomType={'x'} panKey={'shift'}/>*/}

          <Chart/>
          <Legend align={'left'} verticalAlign={'top'} x={40} y={30}/>
          {/*<Tooltip  valueSuffix={' ' + units} valueDecimals={2}/>*/}
          <Tooltip shared={true} split={false} valueSuffix={' ' + units} valueDecimals={2}/>

          <Title style={{color: primaryColor[2]}} align={'center'}>
            {title}
          </Title>

          <XAxis/>
          <YAxis >
            <YAxis.Title text={measurement + ' [' + units + ']'}/>

            {seriesList.filter(series => series.data.length > 0).map(series => {
              const id = series.name.replace(' ', '');
              if (columns) {
                return <ColumnSeries yAxis={0} key={id} id={id} name={series.name}
                                     data={series.data}/>;
              } else {
                //tooltip={{valueSuffix: ' ' + units}}
                return <LineSeries yAxis={0} key={id} id={id} name={series.name}
                                   data={series.data}/>;
              }
            })}
          </YAxis>
        </HighchartsStockChart>
      </HighchartsProvider>
      {/*<Typography color={'gray'} variant={'caption'}>*/}
      {/*  Data  wygenerowania: {moment().format('LLL')}*/}
      {/*</Typography>*/}
    </div>
  );
}
